module.exports = __webpack_public_path__ + "fonts/KaTeX_SansSerif-Regular.2f7bc36.ttf";